import React from 'react';
import { Outlet } from 'react-router-dom';

interface ReportsRootPageInterface {}

const ReportsRoorPage: React.FC<ReportsRootPageInterface> = () => <Outlet />;

export default ReportsRoorPage;
